export default "__VITE_ASSET__Ce9d$Apk__"